import { BaseEdge, getBezierPath, type EdgeProps } from '@xyflow/react';
import './ArchitectureGraph.css';
import { edgeClassName, edgeActivityLabel } from './graph-utils';
import type { ArchitectureFlowEdge } from './types';

export function ArchitectureGraphEdge({
  source,
  target,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
  data,
}: EdgeProps<ArchitectureFlowEdge>) {
  if (!data) return null;
  const [edgePath, labelX, labelY] =
    source === target
      ? selfLoopPath(sourceX, sourceY, targetX, targetY)
      : getBezierPath({
          sourceX,
          sourceY,
          targetX,
          targetY,
          sourcePosition,
          targetPosition,
        });
  const label = edgeActivityLabel(data.topologyEdge);
  return (
    <>
      <BaseEdge
        path={edgePath}
        {...(markerEnd ? { markerEnd } : {})}
        className={edgeClassName(data)}
      />
      <foreignObject
        x={labelX - 75}
        y={labelY - 11}
        width={150}
        height={22}
        className="overflow-visible"
      >
        <div className="rounded bg-white px-1.5 py-0.5 text-center text-[10px] font-semibold text-neutral-600 shadow-sm">
          {label}
        </div>
      </foreignObject>
    </>
  );
}

function selfLoopPath(sourceX: number, sourceY: number, targetX: number, targetY: number) {
  const loopX = Math.max(sourceX, targetX) + 56;
  const loopY = Math.min(sourceY, targetY) - 52;
  const middleX = (sourceX + targetX) / 2;
  return [
    `M ${sourceX},${sourceY} C ${loopX},${sourceY} ${loopX},${loopY} ${middleX},${loopY} C ${targetX - 24},${loopY} ${targetX},${targetY} ${targetX},${targetY}`,
    loopX,
    loopY,
  ] as const;
}
